import { BreadCrumb, BreadCrumbs } from '@picsart/design-system/components/BreadCrumbs';
import { useNavigate, useParams } from 'react-router-dom';

import { getBreadCrumbsList } from '../utils/utils';

import { LandingsType } from '../types';
import useStyles from './styles';

const CustomBreadCrumbs = ({ landings }: { landings: LandingsType[] }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { page } = useParams();
  const breadCrumbsList = getBreadCrumbsList(page, landings);

  return (
    <BreadCrumbs className={styles.breadcrumbWrapper}>
      {breadCrumbsList.map(({ name, slug }, index) => {
        const isActive = index === breadCrumbsList.length - 1;
        return (
          <BreadCrumb
            className={styles.breadCrumb}
            key={slug || index}
            isActive={isActive}
            onClick={() => navigate(slug)}
            data-testid="top-navigation-item"
          >
            {name}
          </BreadCrumb>
        );
      })}
    </BreadCrumbs>
  );
};

export default CustomBreadCrumbs;
